export const queryKeys = {
  all: ["tournaments-data"] as const,
  teamRankings: (game: string, category: string, teamId?: string) =>
    [...queryKeys.all, "rankings", game, category, teamId] as const,
  teamPlayersTimeline: (teamId?: string) => [...queryKeys.all, "team", "players", teamId] as const,
  tournamentTeams: (tournamentId?: string) => [...queryKeys.all, "tournament", "teams", tournamentId] as const,
  tournamentPrizes: (tournamentId?: string) => [...queryKeys.all, "prizes", tournamentId] as const,
  timeline: (gameId: string) => [...queryKeys.all, "timeline", gameId] as const,
};
